<template>
  <div class="quincy-wrapper">
    <ul
      class="quincy-wrapper__symptomtypes"
      :class="{ disabled: activeSymptom }"
      v-if="activeSymptomTypes && activeSymptomTypes.length > 1"
      data-cy="quincy-symptomtypes"
    >
      <template v-for="symptomType in activeSymptomTypes">
        <li
          class="quincy-wrapper__symptomtypes__type noselect"
          data-cy="quincy-symptomtypes-symptomtype"
          :data-draw-type="symptomType.value"
          :key="symptomType.value"
          @click="setActiveType(symptomType.value)"
          v-if="
            interactable === true &&
              report &&
              report.editable
          "
          :class="{ active: $ACTIVETYPE === symptomType.value }"
        >
          <div
            class="circle"
            :style="`background-color: ${SYMPTOM_TYPE_COLORS[symptomType.value].replace('0x', '#')}`"
          ></div>
          <div
            class="text"
            v-text="symptomType.display"
          ></div>
        </li>
      </template>
    </ul>
    <div
      id="canvas-container"
      ref="canvas"
      :class="[cursor]"
      data-cy="quincy-canvas"
    ></div>
    <div class="quincy-wrapper__control-wrapper">
      <div class="quincy-wrapper__controls" data-cy="quincy-controls">
        <camera-toggle></camera-toggle>
        <play-toggle v-if="rotate"></play-toggle>
        <template v-if="interactable && report && report.editable && !isResearchView">
          <draw-toggle></draw-toggle>
          <template v-if="activeSymptom">
            <erase-toggle></erase-toggle>
            <delete-symptom></delete-symptom>
          </template>
        </template>
      </div>
    </div>

    <!-- <transition name="fade-in-right" mode="out-in">
      <div class="quincy-wrapper__intensity-wrapper" v-if="activeSymptom">
        <div class="quincy-wrapper__intensity">
          <intensity-scale-vue
            :active-symptom="activeSymptom"
            data-cy="quincy-intensity"
          ></intensity-scale-vue>
        </div>
      </div>
    </transition> -->
  </div>
</template>

<script>
import { SYMPTOM_TYPE_COLORS } from '@common/constants';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { GETTERS, MUTATIONS, ACTIONS } from '../store/quincy/definitions.js';
import { symptomTypes } from '@common/Helpers/symptoms.js';
import core from '../store/quincy/core.js';

import LoadingManager from '@common/Modules/quincy/src/library/LoadingManager.js';
import SymptomReportModel from '@common/Models/SymptomReport/SymptomReportModel.js';
import { events, controls, symptom } from './mixins';

import CameraToggle from './components/CameraToggle.vue';
import DrawToggle from './components/DrawToggle.vue';
import EraseToggle from './components/EraseToggle.vue';
import PlayToggle from './components/PlayToggle.vue';
import DeleteSymptom from './components/DeleteSymptom.vue';

const THREE = require('three');
let id;
let inte = 0;

import CameraControls from 'camera-controls';

CameraControls.install( { THREE: THREE } );

export default {
  name: 'Quincy',
  mixins: [events, controls, symptom],
  components: {
    CameraToggle,
    DrawToggle,
    EraseToggle,
    DeleteSymptom,
    PlayToggle
  },
  props: {
    symptomreport: {
      type: SymptomReportModel,
      required: false
    },
    interactable: {
      type: Boolean,
      default: true
    },
    rotate: {
      type: Boolean,
      default: false
    },
    model: {
      type: String
    },
    loadBalls: {
      type: Boolean,
      default: true
    },
    activeSymptomTypes: {
      validator: function(value) {
        const neededProps = ['display', 'value'];
        let valid = true;
        value.forEach(v => {
          neededProps.forEach(p => (valid = v.hasOwnProperty(p) || v === []));
        });
        return valid;
      },
      type: Array,
      required: true
    }
  },
  data() {
    return {
      SYMPTOM_TYPE_COLORS,
      quincySubscriptions: null,
      lastRender: null,
      renderTimer: null,
    };
  },
  watch: {
    symptomreport: {
      handler: function(report) {
        this.$SETSYMPTOMREPORT(report);
      },
      immediate: true
    },
    $ACTIVESYMPTOM(symptom) {
      this.$emit('active-symptom', symptom);
    }
  },
  beforeUnmount() {
    this.$refs.canvas.innerHTML = '';
    this.quincySubscriptions();
  },
  beforeMount() {
    if (this.model) {
      this.$SETMODEL(this.model);
      this.$SETAVAILABLETYPES(this.activeSymptomTypes.map(x => x.value));
    }
  },
  mounted() {
    if (this.interactable === true) {
      if (this.$ACTIVETYPE.length) {
        const activeType = this.activeSymptomTypes.find(
          t => t.value === this.$ACTIVETYPE
        );
        if (activeType) {
          this.$SETACTIVETYPE(
            this.activeSymptomTypes.find(t => t.value === this.$ACTIVETYPE)
              .value
          );
        } else {
          this.$SETACTIVETYPE(this.activeSymptomTypes[0].value);
        }
      } else {
        this.$SETACTIVETYPE(this.activeSymptomTypes[0].value);
      }
    }

    this.quincySubscriptions = this.$store.subscribe(mutation => {
      const removeReg = new RegExp(`quincy/REMOVE_.+?_SYMPTOM`);
      if (mutation.type.match(removeReg)) {
        console.log('removed symptom', mutation.type);
      }

      if(mutation.type === `quincy/${MUTATIONS.SAVE_ACTIVE_SYMPTOM}`) {
        this.forceRender();
        console.log(core.controls.getPosition());
      }

      if(mutation.type === `quincy/${MUTATIONS.REMOVE_ENTIRE_DRAWING}`) {
        this.forceRender();
      }

      if (
        mutation.type === `quincy/${MUTATIONS.TOGGLE_CONTROLS}` &&
        mutation.payload.hasOwnProperty('play') &&
        this.rotate
      ) {
        core.controls.autoRotate = this.$SETTINGS.controls.play;
        if (mutation.payload.play) {
          this.startRenderTimer();
        } else {
          this.stopRenderTimer();
        }
      } else if (
        mutation.type === `quincy/${MUTATIONS.TOGGLE_CONTROLS}` &&
        !mutation.payload.hasOwnProperty('play') &&
        this.rotate
      ) {
        core.controls.autoRotate = false;
      }

      if (mutation.type === `quincy/${MUTATIONS.CLICK_SYMPTOM}`) {
        this.$emit('click-symptom', mutation.payload.SymptomId);
      }
    });

    this.init();
    this.$INIT({ interactable: this.interactable, rotate: this.rotate });
  },
  methods: {
    ...mapMutations('quincy', {
      $SETSYMPTOMREPORT: MUTATIONS.SET_SYMPTOMREPORT,
      $SETACTIVETYPE: MUTATIONS.SET_ACTIVE_TYPE,
      $SETAVAILABLETYPES: MUTATIONS.SET_AVAILABLE_TYPES,
      $MODELLOADED: MUTATIONS.MODEL_LOADED,
      $TOGGLECONTROLS: MUTATIONS.TOGGLE_CONTROLS,
      $SETMODEL: MUTATIONS.SET_MODEL
    }),
    ...mapActions('quincy', {
      $INIT: ACTIONS.INIT
    }),
    init() {
      this.removeAllMarkers();
      core.container = this.$refs.canvas;
      // renderer
      core.renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
      core.renderer.setPixelRatio(window.devicePixelRatio);
      core.renderer.setSize(
        core.container.clientWidth,
        core.container.clientHeight
      );
      core.renderer.autoClear = false;
      core.container.appendChild(core.renderer.domElement);

      core.renderer.setClearColor(0xffffff);
      core.renderer.autoClear = true;


      core.clock = new THREE.Clock();

      // camera
      core.camera = new THREE.PerspectiveCamera(
        30,
        core.container.clientWidth / core.container.clientHeight,
        0.01,
        1000
      );
      core.camera.target = new THREE.Vector3();
      core.camera.position.set(
        0,
        core.constants.CAMERA_HEIGHT,
        core.constants.CAMERA_ZOOM
      );
      // core.camera.lookAt(new THREE.Vector3(0, 0, 0));

      // controls
      core.controls = new CameraControls(core.camera, core.container);
      core.controls.minDistance = 5;
      core.controls.maxDistance = 50;
      core.controls.enablePan = true;
      core.controls.enabled = true;
      core.controls.screenSpacePanning = true;
      core.controls.enableKeys = false;
      core.controls.dollyToCursor = true;

      core.controls.addEventListener('control', () => {
        if (this.active) this.needToReset = true;
        // this.triggerRenderMovement();
      });

      // core.controls.addEventListener('update', () => {
      //   this.render();
      // });

      core.scene = new THREE.Scene();

      // const size = 10;
      // const divisions = 10;
      // const gridHelper = new THREE.GridHelper( size, divisions );
      // core.scene.add( gridHelper );

      this.loadModel(this.$ACTIVEMODEL.Model);
    },

    render() {
      try {
        const hasControlsUpdated = core.controls.update( core.clock.getDelta() );
        requestAnimationFrame( this.render );

        if (hasControlsUpdated || this.drawActive || this.eraseActive ||this.$router.currentRoute.name == 'GroupSymptomsVisualizationView') {
          this.forceRender();
        }
        if (core.raycaster) {
          core.raycaster.setFromCamera(this.cursorPosition, core.camera);
        }
      } catch (error) {
        // cancelAnimationFrame(id);
      }
    },
    forceRender() {
      core.renderer.clear();
      core.renderer.clearDepth();
      core.renderer.render(core.scene, core.camera);
    },
    triggerRender(from) {
      console.log('trigger', from);

      this.forceRender();
    },
    triggerRenderMovement() {
      const now = Date.now();
      if (now - this.lastRender < 17) {
        return;
      }
      this.lastRender = Date.now();
      this.render();
    },
    loadModel(model) {
      LoadingManager.loadObject(`/${model}`, loadedObject => {
        core.object = loadedObject;
        let material;

        material = new THREE.MeshLambertMaterial({
          color: 0xffffff
        });
        this.addLights();

        core.object.traverse(child => {
          if (child instanceof THREE.Mesh) {
            child.material = material;
          }
        });

        core.object.castShadow = true;
        core.object.name = model;

        core.scene.add(loadedObject);

        // var box = new THREE.BoxHelper( core.object, 0xffffff );
        // core.scene.add( box );

        const boundingBox = new THREE.Box3();
        boundingBox.setFromObject(core.object);

        if (core.controls.target === undefined) {
          core.controls.target = new THREE.Vector3();
        }

        boundingBox.getCenter(core.controls.target);

        core.boundingBox = boundingBox;

        core.controls.fitToBox(boundingBox, false, { paddingBottom: 0.5 });

        setTimeout(() => this.render(), 100);

        const pos = core.controls.getPosition();
        core.controls.setPosition(pos.x, pos.y, pos.z * -1, false);

        this.$MODELLOADED(true);
        this.loaded = true;
      });
    },

    addLights() {
      const lightCount = core.scene.children.filter(
        child => child.name === 'light'
      ).length;

      if (lightCount == 5) {
        return;
      }

      let spotLight = new THREE.SpotLight(0xffffff);
      spotLight.position.set(-10, 50, -150);
      spotLight.castShadow = true;
      spotLight.name = 'light';
      core.scene.add(spotLight);

      spotLight = new THREE.SpotLight(0xffffff);
      spotLight.position.set(10, 20, 150);
      spotLight.castShadow = true;
      spotLight.name = 'light';
      core.scene.add(spotLight);

      spotLight = new THREE.SpotLight(0x112033);
      spotLight.position.set(-40, 25, 0.271335);
      spotLight.castShadow = true;
      spotLight.name = 'light';
      core.scene.add(spotLight);

      spotLight = new THREE.SpotLight(0x112033);
      spotLight.position.set(40, 25, 0.271335);
      spotLight.castShadow = true;
      spotLight.name = 'light';
      core.scene.add(spotLight);

      let ambientLight = new THREE.AmbientLight(0x112033, 0.1);
      ambientLight.name = 'light';
      core.scene.add(ambientLight);
    },
    setActiveType(type) {
      this.$SETACTIVETYPE(type);
      this.$TOGGLECONTROLS({ draw: true });
    },
    startRenderTimer() {
      this.renderTimer = setInterval(() => this.triggerRender(), 30);
    },
    stopRenderTimer() {
      window.clearInterval(this.renderTimer);
      this.renderTimer = null;
    }
  },
  computed: {
    ...mapGetters('quincy', {
      $SETTINGS: GETTERS.SETTINGS,
      $REPORT: GETTERS.REPORT,
      $ACTIVETYPE: GETTERS.ACTIVE_TYPE,
      $ACTIVESYMPTOM: GETTERS.ACTIVE_SYMPTOM,
      $ACTIVEMODEL: GETTERS.ACTIVE_MODEL
    }),
    report() {
      return this.$REPORT;
    },
    activeSymptom() {
      return this.$ACTIVESYMPTOM;
    },
    drawActive() {
      return this.$SETTINGS.controls.draw;
    },
    isResearchView(){
      return this.$router.currentRoute.name == 'GroupSymptomsVisualizationView';
    },
    cameraActive() {
      return this.$SETTINGS.controls.camera;
    },
    eraseActive() {
      return this.$SETTINGS.controls.erase;
    },
    cursor() {
      if (!this.cameraActive && this.report && this.report.editable === false) {
        return 'not-editable';
      } else if (this.drawActive) {
        return 'draw';
      } else if (this.eraseActive) {
        return 'erase';
      } else if (this.cameraActive) {
        return 'camera';
      }
      return 'normal';
    }
  }
};
</script>

<style lang="scss" scoped>
#canvas-container {
  height: 99%;
  outline: none;
}
</style>

<style lang="scss">
@import '@sass/_variables.scss';
$padding: 10px;
$rotateButtonWidth: 30px;

.quincy-wrapper {
  height: 75vh;
  position: relative;

  &__intensity-wrapper {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    pointer-events: none;
  }

  &__intensity {
    padding: 0 20px 0 30px;
    width: 79px;
    height: 278px;
    display: flex;
    position: relative;
    pointer-events: all;
  }

  &__control-wrapper {
    position: absolute;
    left: $padding * 2;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    pointer-events: none;
  }

  &__controls {
    pointer-events: all;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // width: 29px;
    // height: 29px;
    z-index: 900;
    opacity: 0.9;
    border-radius: 33px;
    box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    padding: 13px;
    cursor: pointer;

    i {
      font-size: 40px;
      line-height: 40px;
    }

    &__rotate-button,
    &__erase-button,
    &__edit-button,
    &__trash-button,
    &__draw-button,
    &__play-button {
      color: black;
      height: 40px;
      border-radius: 33px;
      &:not(:last-of-type) {
        margin-bottom: 10px;
      }
    }
  }

  &__symptomtypes {
    position: absolute;
    left: 0;
    right: 0;
    top: -10px;
    text-align: center;
    margin: -10px 0 -20px 0;
    color: #000;
    &.disabled {
      pointer-events: none;
      opacity: 0.4;
    }
    &__type {
      position: relative;
      display: inline-flex;
      opacity: 0.6;
      align-items: center;
      cursor: pointer;
      &:not(:last-of-type) {
        margin-right: 7px;
      }
      &.active {
        opacity: 1;
        border-bottom: 1px solid black;
        .circle {
          -webkit-filter: grayscale(0%);
          filter: none;
        }
      }
      .circle {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: gray;
        -webkit-filter: grayscale(100%);
        filter: gray;
        display: inline-block;
        margin-right: 5px;
      }
      .text {
        white-space: nowrap;
        text-transform: uppercase;
        font-size: 12px;
        display: inline-flex;
      }
    }
  }
}
</style>
